import React from 'react';
import ExcelImportExport from '../compartidos/ExcelImportExport';
import ModalAgregarMaterial from './ModalAgregarMaterial';
import ModalEditarMaterial from './ModalEditarMaterial';

function TabMatrizMateriales({
  tasks, materiales, sections, materialSections, teamMembers,
  showConfigMateriales, setShowConfigMateriales,
  showMaterialForm, setShowMaterialForm,
  filtrosMateriales, setFiltrosMateriales,
  diasProcesosMateriales, setDiasProcesosMateriales,
  handleSaveProcessDaysMateriales, savingConfigMateriales,
  materialText, setMaterialText,
  materialSpecialty, setMaterialSpecialty,
  materialDueDate, setMaterialDueDate,
  addMaterial,
  materialesFiltrados, renderMaterialTableRows,
  handleImportComplete,
  allMaterialsSelected, selectAllMaterials, clearAllMaterialSelection,
  modoDesdeProgamaMaterial, setModoDesdeProgamaMaterial,
  actividadesMaterial, setActividadesMaterial,
  partidaProgramaMaterial, setPartidaProgramaMaterial,
  actMapPrograma, setActMapPrograma,
  obtenerActividadesKpi,
  nombresPlantillas, cargarNombresPlantillas,
  mostrarSugerenciasMaterial, setMostrarSugerenciasMaterial,
  editMaterialId, editMaterialFields, setEditMaterialFields,
  editMatModoPrograma, setEditMatModoPrograma,
  saveEditMaterial, cancelEditMaterial
}) {
  return (
    <div className="tab-content matriz-materiales-page">
      <section className="progress-section-v2">
        {/* Header */}
        <div className="critical-header-bar">
          <h2 className="matriz-page-title">Materiales</h2>
        </div>

        {/* Botones de acción */}
        <div className="team-actions-row">
          <button 
            className={`team-action-btn ${showConfigMateriales ? 'active-red' : 'amber'}`}
            onClick={() => setShowConfigMateriales(!showConfigMateriales)}
          >
            {showConfigMateriales ? 'Ocultar Config.' : 'Configurar Días'}
          </button>
          <button 
            className={`team-action-btn ${showMaterialForm ? 'active-red' : 'green'}`}
            onClick={() => setShowMaterialForm(!showMaterialForm)}
          >
            {showMaterialForm ? 'Ocultar Formulario' : '+ Agregar Material'}
          </button>
          <ExcelImportExport
            tasks={tasks}
            materiales={materiales}
            sections={sections}
            materialSections={materialSections}
            teamMembers={teamMembers}
            onImportComplete={handleImportComplete}
          />
        </div>

        {/* PANEL DE FILTROS DE MATERIALES */}
        <div className="filtros-panel-mejorado">
          <div className="filtros-grid">
            <div className="filtro-campo">
              <label className="filtro-label">Buscar</label>
              <input
                type="text"
                placeholder="Nombre de material..."
                value={filtrosMateriales.texto}
                onChange={(e) => setFiltrosMateriales({...filtrosMateriales, texto: e.target.value})}
                className="filtro-input"
              />
            </div>
            
            <div className="filtro-campo">
              <label className="filtro-label">Especialidad</label>
              <select
                value={filtrosMateriales.especialidad}
                onChange={(e) => setFiltrosMateriales({...filtrosMateriales, especialidad: e.target.value})}
                className="filtro-select"
              >
                <option value="todas">Todas las especialidades</option>
                {materialSections.map(section => (
                  <option key={section.id} value={section.name}>{section.name}</option>
                ))}
              </select>
            </div>
            
            <div className="filtro-campo">
              <label className="filtro-label">Responsable</label>
              <select
                value={filtrosMateriales.responsable}
                onChange={(e) => setFiltrosMateriales({...filtrosMateriales, responsable: e.target.value})}
                className="filtro-select"
                style={{ borderColor: '#374151' }}
              >
                <option value="todos">Todos</option>
                <option value="sin-responsable">Sin responsable</option>
                {teamMembers.map(member => (
                  <option key={member.id} value={member.id}>{member.name}</option>
                ))}
              </select>
            </div>
            
            <div className="filtro-campo">
              <label className="filtro-label">Proceso</label>
              <select
                value={filtrosMateriales.proceso}
                onChange={(e) => setFiltrosMateriales({...filtrosMateriales, proceso: e.target.value})}
                className="filtro-select"
              >
                <option value="todos">Todos los procesos</option>
                <option value="inicio">Inicio</option>
                <option value="cubicacion">Cubicación</option>
                <option value="revCubicacion">Rev. Cubicación</option>
                <option value="solped">Solped</option>
                <option value="ocAprobada">OC Aprobada</option>
                <option value="materialEnObra">Material en Obra</option>
              </select>
            </div>
            
            <div className="filtro-campo-especial">
              <label className="filtro-checkbox-label">
                <input
                  type="checkbox"
                  checked={filtrosMateriales.criticos}
                  onChange={(e) => setFiltrosMateriales({...filtrosMateriales, criticos: e.target.checked})}
                  className="filtro-checkbox"
                />
                <span className="checkbox-texto">Solo críticos (7 días)</span>
              </label>
            </div>

            <div className="filtro-campo-especial">
              <label className="filtro-checkbox-label">
                <input
                  type="checkbox"
                  checked={filtrosMateriales.pendientes}
                  onChange={(e) => setFiltrosMateriales({...filtrosMateriales, pendientes: e.target.checked})}
                  className="filtro-checkbox"
                />
                <span className="checkbox-texto">Solo pendientes</span>
              </label>
            </div>

            <div className="filtro-campo-especial">
              <button
                onClick={() => setFiltrosMateriales({ texto: '', especialidad: 'todas', criticos: false, pendientes: false, proceso: 'todos', responsable: 'todos' })}
                className="filtro-btn-limpiar"
              >
                Limpiar
              </button>
            </div>
          </div>
        </div>

        {/* Configuración de días por proceso */}
        {showConfigMateriales && (
          <section className="config-section">
            <h2>Configurar días por proceso</h2>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '15px' }}>
              Esta configuración afectará a todos los materiales futuros que agregues.
            </p>
            <div className="config-inputs">
              <div>
                <label>CUBICACIÓN (DIAS): </label>
                <input type="number" min="0" value={diasProcesosMateriales.inicio} onChange={(e) => setDiasProcesosMateriales({...diasProcesosMateriales, inicio: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>REV CUBICACIÓN (DIAS): </label>
                <input type="number" min="0" value={diasProcesosMateriales.cubicacion} onChange={(e) => setDiasProcesosMateriales({...diasProcesosMateriales, cubicacion: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>SOLPED (DIAS): </label>
                <input type="number" min="0" value={diasProcesosMateriales.revCubicacion} onChange={(e) => setDiasProcesosMateriales({...diasProcesosMateriales, revCubicacion: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>OC APROBADA (DIAS): </label>
                <input type="number" min="0" value={diasProcesosMateriales.solped} onChange={(e) => setDiasProcesosMateriales({...diasProcesosMateriales, solped: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>MATERIAL EN OBRA (DIAS): </label>
                <input type="number" min="0" value={diasProcesosMateriales.ocAprobada} onChange={(e) => setDiasProcesosMateriales({...diasProcesosMateriales, ocAprobada: parseInt(e.target.value) || 0})} />
              </div>
              <div>
                <label>INICIO DE PARTIDA (DIAS): </label>
                <input type="number" min="0" value={diasProcesosMateriales.materialEnObra} onChange={(e) => setDiasProcesosMateriales({...diasProcesosMateriales, materialEnObra: parseInt(e.target.value) || 0})} />
              </div>
            </div>
            <button
              onClick={handleSaveProcessDaysMateriales}
              disabled={savingConfigMateriales}
              className="save-config-button"
              style={{
                marginTop: '20px',
                backgroundColor: savingConfigMateriales ? '#9ca3af' : '#10b981',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                borderRadius: '6px',
                cursor: savingConfigMateriales ? 'not-allowed' : 'pointer',
                fontWeight: '600',
                fontSize: '14px',
                transition: 'background-color 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
              onMouseOver={(e) => !savingConfigMateriales && (e.target.style.backgroundColor = '#059669')}
              onMouseOut={(e) => !savingConfigMateriales && (e.target.style.backgroundColor = '#10b981')}
            >
              {savingConfigMateriales ? (
                <>
                  <span style={{
                    width: '16px',
                    height: '16px',
                    border: '2px solid #ffffff',
                    borderTop: '2px solid transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.6s linear infinite',
                    display: 'inline-block'
                  }}></span>
                  Guardando...
                </>
              ) : (
                <>Guardar Configuración</>
              )}
            </button>
          </section>
        )}
        
        {/* Formulario para agregar material (modal) */}
        <ModalAgregarMaterial
          visible={showMaterialForm}
          onCerrar={() => setShowMaterialForm(false)}
          materialSections={materialSections}
          materialText={materialText} setMaterialText={setMaterialText}
          materialSpecialty={materialSpecialty} setMaterialSpecialty={setMaterialSpecialty}
          materialDueDate={materialDueDate} setMaterialDueDate={setMaterialDueDate}
          addMaterial={addMaterial}
          modoDesdeProgamaMaterial={modoDesdeProgamaMaterial} setModoDesdeProgamaMaterial={setModoDesdeProgamaMaterial}
          actividadesMaterial={actividadesMaterial} setActividadesMaterial={setActividadesMaterial}
          partidaProgramaMaterial={partidaProgramaMaterial} setPartidaProgramaMaterial={setPartidaProgramaMaterial}
          actMapPrograma={actMapPrograma} setActMapPrograma={setActMapPrograma}
          obtenerActividadesKpi={obtenerActividadesKpi}
          nombresPlantillas={nombresPlantillas} cargarNombresPlantillas={cargarNombresPlantillas}
          mostrarSugerenciasMaterial={mostrarSugerenciasMaterial} setMostrarSugerenciasMaterial={setMostrarSugerenciasMaterial}
        />

        {/* Formulario de edición de Material (modal) */}
        <ModalEditarMaterial
          visible={editMaterialId !== null}
          onCerrar={cancelEditMaterial}
          materialSections={materialSections}
          editMaterialFields={editMaterialFields} setEditMaterialFields={setEditMaterialFields}
          editMatModoPrograma={editMatModoPrograma} setEditMatModoPrograma={setEditMatModoPrograma}
          actividadesMaterial={actividadesMaterial} setActividadesMaterial={setActividadesMaterial}
          actMapPrograma={actMapPrograma} setActMapPrograma={setActMapPrograma}
          obtenerActividadesKpi={obtenerActividadesKpi}
          saveEditMaterial={saveEditMaterial}
          editMaterialId={editMaterialId}
        />

        {/* Contador de resultados de filtros */}
        {(filtrosMateriales.texto || filtrosMateriales.especialidad !== 'todas' || filtrosMateriales.criticos || filtrosMateriales.pendientes) && (
          <div style={{
            padding: '10px 15px',
            backgroundColor: '#f3f4f6',
            borderRadius: '6px',
            marginBottom: '12px',
            fontSize: '14px',
            color: '#374151'
          }}>
            Mostrando {materialesFiltrados.length} de {materiales.length} materiales
          </div>
        )}

        {/* Tabla de Materiales */}
        <div className="table-wrapper">
          <table className="tasks-table">
            <thead>
              <tr>
                <th className="checkbox-seleccion">
                  <div className="checkbox-header-container">
                    <input
                      type="checkbox"
                      className="checkbox-seleccion-input"
                      checked={allMaterialsSelected}
                      onChange={(e) => e.target.checked ? selectAllMaterials() : clearAllMaterialSelection()}
                      title={allMaterialsSelected ? 'Deseleccionar todos' : 'Seleccionar todos'}
                    />
                  </div>
                </th>
                <th>Responsable</th>
                <th>Material</th>
                {filtrosMateriales.proceso === 'todos' ? (
                  <>
                    <th style={{ width: '95px' }}>Inicio</th>
                    <th style={{ width: '95px' }}>Cubicación</th>
                    <th style={{ width: '95px' }}>Rev Cubicación</th>
                    <th style={{ width: '95px' }}>Solped</th>
                    <th style={{ width: '95px' }}>OC Aprobada</th>
                    <th style={{ width: '95px' }}>Material en Obra</th>
                  </>
                ) : (
                  <th>
                    {filtrosMateriales.proceso === 'inicio' && 'Inicio'}
                    {filtrosMateriales.proceso === 'cubicacion' && 'Cubicación'}
                    {filtrosMateriales.proceso === 'revCubicacion' && 'Rev Cubicación'}
                    {filtrosMateriales.proceso === 'solped' && 'Solped'}
                    {filtrosMateriales.proceso === 'ocAprobada' && 'OC Aprobada'}
                    {filtrosMateriales.proceso === 'materialEnObra' && 'Material en Obra'}
                  </th>
                )}
                <th>Inicio de Partida</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {materiales.length === 0 ? (
                <tr>
                  <td colSpan="12">No hay materiales añadidos</td>
                </tr>
              ) : (
                renderMaterialTableRows()
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}

export default TabMatrizMateriales;
